import { createFileRoute } from "@tanstack/react-router";
import { InfoLayout } from "@/components/laneguide/InfoLayout";

export const Route = createFileRoute("/om-oss/redaktion")({
  head: () => ({ meta: [{ title: "Vår redaktion | Svensk Låneguide" }] }),
  component: () => (
    <InfoLayout title="Vår redaktion">
      <h2>Syftet med vårt innehåll</h2>
      <p>Vår målsättning med det redaktionella innehållet på Svensk Låneguide är att tillhandahålla korrekt, relevant och lättillgänglig information till våra läsare. Vi strävar efter att skapa innehåll som är engagerande, informativt och värdefullt – och som hjälper våra läsare att fatta välgrundade beslut. Genom vårt arbetssätt säkerställer vi att allt innehåll uppfyller våra höga standarder för kvalitet och integritet.</p>
      <h2>Redaktionella riktlinjer</h2>
      <p>Produktionen av vårt redaktionella material är en process i flera steg som innefattar skribenter, redaktörer och designers. En skribent tilldelas uppgiften att producera en artikel, jämförelsesida eller nyhet, gör research och skapar ett första utkast. Redaktören granskar texten och gör ändringar. Slutligen anpassar en designer materialet för att passa in på Svensk Låneguide.</p>
      <h2>Framtagande av innehåll</h2>
      <ol className="list-decimal pl-6 space-y-1">
        <li><b>Ämnesval</b> – ett relevant ämne väljs med en idé om utformning.</li>
        <li><b>Uppdragsfördelning</b> – en skribent tilldelas uppgiften.</li>
        <li><b>Förberedande research</b> – skribenten bygger en överblick.</li>
        <li><b>Utkast</b> – ett första utkast tas fram.</li>
        <li><b>Första granskningen</b> – redaktör ger feedback.</li>
        <li><b>Revision</b> – författaren gör nödvändiga ändringar.</li>
        <li><b>Slutlig granskning</b> – slutgiltiga justeringar görs.</li>
        <li><b>Design och publicering</b> – innehållet anpassas och publiceras.</li>
      </ol>
      <h2>Innehållskrav</h2>
      <p><b>Relevans:</b> Innehållet ska vara anpassat till våra läsares behov och intressen.</p>
      <p><b>Kvalitet:</b> Välskrivet, noggrant efterforskat och felfritt.</p>
      <p><b>Originalitet:</b> Allt innehåll ska vara unikt – vi tolererar inte plagiat.</p>
      <p><b>Transparens:</b> Vi anger källor och är tydliga med eventuella intressekonflikter.</p>
      <p><b>Användarvänlighet:</b> Klar och enkel språkstil, organiserat för att läsaren snabbt ska hitta rätt information.</p>
    </InfoLayout>
  ),
});
